import useAPI from '../../../services/useAPI';
import React from 'react';
import { useQuery } from '@tanstack/react-query';

import createQueryRequest from 'services/createQueryRequest';

import WizardStepDataSource from './components/WizardStepDataSource';

export const BindingsStep = ({ assetInfo, setAssetInfo, onError, setIsValid }) => {
  const api = useAPI();

  const query = useQuery(['providers'],
    createQueryRequest(api.core.getProviders),
  );
  const providers = query.data;

  return (
    <WizardStepDataSource
      assetInfo={assetInfo}
      setAssetInfo={setAssetInfo}
      addErrorAlert={onError}
      providers={providers}
      isLoadingProviders={query.isLoading}
      setIsValid={setIsValid}
    />
  );
};
